import React, { useEffect } from 'react';
import { MainTable } from '../../../Components/MainTable/MainTable';
import { useColors } from './ColorStore';
import Add from './Add';
import Edit from './Edit';
function Colors(props) {
    let { colors, columns, getColors, deleteColor, setEd } = useColors();
    useEffect(() => {
        getColors()
    }, [])
    return (
        <MainTable
            pageTitle='Rangi'
            pcolumns={columns}
            pdata={colors}
            add={<Add />}
            edit={<Edit />}
            defkey={'id'}
            onDelete={(e, rec) => {
                deleteColor(rec.id)
            }}
            onEdit={(rec) => {
                setEd(rec)
            }}
            setEd={setEd}
        />
    );
}

export default Colors;